// extracted by mini-css-extract-plugin
export var button = "_o3-2";
export var card = "_o3-0";
export var closeButtonContainer = "_o3-3";
export var iconContainer = "_o3-1";